import en from "./_i18n/en.json";

/** English text for `tour.<node>`, the fallback passed to t(). One source. */
export const fallbackCopy = (node: string): string => {
  const value = node
    .split(".")
    .reduce<unknown>((acc, part) => (acc as Record<string, unknown> | undefined)?.[part], en.tour);
  return typeof value === "string" ? value : node;
};
